import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

export const getAuditLogsAPI = (params = {}) => httpClient.get(ENDPOINT_API.AUDIT_LOG, { params });
export const getAuditLogAPI = (id) => httpClient.get(`${ENDPOINT_API.AUDIT_LOG}/${id}`);
export const getAuditLogOptionAPI = () => httpClient.get(`${ENDPOINT_API.AUDIT_LOG}/filters`);


